import { TOKEN_USED, RESET_TOKEN } from "../constants/ActionTypes";

export const useToken = state => ({
  type: TOKEN_USED
});

export const resetToken = state => ({
  type: RESET_TOKEN
});
